import { authenticationStore, AuthenticationStore } from './AuthenticationStore';
import { reaction, makeAutoObservable } from 'mobx';
import { logger } from '../Utils/logger';
import { getAthleteFullName } from '../Model/Athlete/Athlete';

function createSupportStore(authentication: AuthenticationStore) {
  const store = makeAutoObservable({
    authentication,
  });

  reaction(
    () => authentication.athlete,
    (athlete) => {
      if (athlete?.user.email && (window as any).FreshworksWidget) {
        (window as any).FreshworksWidget('identify', 'ticketForm', {
          name: getAthleteFullName(athlete),
          email: athlete.user.email,
        });
      } else if ((window as any).FreshworksWidget) {
        logger('hiding widget');
        (window as any).FreshworksWidget('identify', 'ticketForm', {
          name: '',
          email: '',
        });
        // (window as any).FreshworksWidget('hide');
      }
    },
    { fireImmediately: true },
  );

  return store;
}

export const supportStore = createSupportStore(authenticationStore);
export type SupportStore = ReturnType<typeof createSupportStore>;
